export default __webpack_public_path__ + "background-industry-finance.jpg?c93fcf18d659c1f3196acda31dc04b52";